import { render, staticRenderFns } from "./AdsTemplate.vue?vue&type=template&id=f807ec18&"
import script from "./AdsTemplate.vue?vue&type=script&lang=ts&"
export * from "./AdsTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports